(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat-banner/assets/javascripts/match-header.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat-banner/assets/javascripts/match-header.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const SportinfoMatchState = svs.components.sportinfo.common.matchState.SportinfoMatchState;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const _svs$components$lbUi$ = svs.components.lbUi.participants,
  SmartAbbr = _svs$components$lbUi$.SmartAbbr,
  _svs$components$lbUi$2 = _svs$components$lbUi$.constants,
  DescriptionSize = _svs$components$lbUi$2.DescriptionSize,
  getTeamName = _svs$components$lbUi$2.getTeamName;
const trimTeamName = (teamName, maxLength) => {
  if (!teamName || teamName.length <= maxLength) {
    return teamName;
  }
  return "".concat(teamName.substr(0, maxLength - 1).trim(), ".");
};
const getTeamNameAndTitle = (participant, isLargeDevice) => {
  const nameSize = isLargeDevice ? DescriptionSize.Medium : DescriptionSize.Full;
  const name = getTeamName(participant, nameSize);
  const trimmedName = isLargeDevice ? trimTeamName(name, 15) : name;
  const title = (participant === null || participant === void 0 ? void 0 : participant.name) || name;
  return [trimmedName, title];
};
const SvSMatchHeader = _ref => {
  let matchState = _ref.matchState,
    homeTeam = _ref.homeTeam,
    eventNumber = _ref.eventNumber,
    awayTeam = _ref.awayTeam,
    results = _ref.results;
  const isMediumDevice = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const isLargeDevice = useMediaQuery(breakpoints.down(BREAKPOINT_LG));
  const _getTeamNameAndTitle = getTeamNameAndTitle(homeTeam, isLargeDevice),
    _getTeamNameAndTitle2 = _slicedToArray(_getTeamNameAndTitle, 2),
    homeTeamName = _getTeamNameAndTitle2[0],
    homeTeamTitle = _getTeamNameAndTitle2[1];
  const _getTeamNameAndTitle3 = getTeamNameAndTitle(awayTeam, isLargeDevice),
    _getTeamNameAndTitle4 = _slicedToArray(_getTeamNameAndTitle3, 2),
    awayTeamName = _getTeamNameAndTitle4[0],
    awayTeamTitle = _getTeamNameAndTitle4[1];
  const teamNameClass = "sportinfo_bigstat_header__participants f-content h".concat(isMediumDevice ? 3 : 1);
  const scoreClassname = "f-content ".concat(isMediumDevice ? 'f-400 f-medium' : 'h2');
  if (matchState === SportinfoMatchState.NotStarted || !results) {
    return React.createElement("div", {
      "aria-label": "".concat(homeTeamName, " mot ").concat(awayTeamName),
      className: "sportinfo_bigstat_header__participants--with_event_number ".concat(teamNameClass)
    }, React.createElement("span", {
      className: "sportinfo_bigstat_header__event_number"
    }, eventNumber && React.createElement(React.Fragment, null, React.createElement("span", {
      "aria-hidden": true,
      className: "sportinfo_bigstat_header__event_number_text"
    }, eventNumber), React.createElement("span", {
      "aria-hidden": true,
      className: "sportinfo_bigstat_header__event_number_dot"
    }, "."))), React.createElement("span", {
      "aria-hidden": true,
      className: "sportinfo_bigstat_header__participants_name sportinfo_bigstat_header__participants_name--home home-participant"
    }, React.createElement(SmartAbbr, {
      title: homeTeamTitle
    }, homeTeamName)), React.createElement("span", {
      "aria-hidden": true,
      className: "participant-split"
    }, " - "), React.createElement("span", {
      "aria-hidden": true,
      className: "sportinfo_bigstat_header__participants_name sportinfo_bigstat_header__participants_name--away away-participant"
    }, React.createElement(SmartAbbr, {
      title: awayTeamTitle
    }, awayTeamName)));
  }
  return React.createElement("div", {
    "aria-label": "".concat(homeTeamName, " mot ").concat(awayTeamName, ", resultat ").concat(results.home, " - ").concat(results.away),
    className: "match-header-holder sportinfo_bigstat_header__participants sportinfo_bigstat_header__participants--with_score_board"
  }, React.createElement("div", {
    "aria-hidden": true,
    className: "sportinfo_bigstat_header__participants_name sportinfo_bigstat_header__participants_name--home team-name-left ".concat(teamNameClass)
  }, React.createElement(SmartAbbr, {
    title: homeTeamTitle
  }, homeTeamName)), React.createElement("div", {
    "aria-hidden": true,
    className: "score-holder"
  }, React.createElement("div", {
    className: "score-number ".concat(scoreClassname)
  }, results.home), React.createElement("div", {
    className: "score-number ".concat(scoreClassname)
  }, results.away)), React.createElement("div", {
    "aria-hidden": true,
    className: "sportinfo_bigstat_header__participants_name sportinfo_bigstat_header__participants_name--away team-name-right ".concat(teamNameClass)
  }, React.createElement(SmartAbbr, {
    title: awayTeamTitle
  }, awayTeamName)));
};
const MatchHeader = _ref2 => {
  let matchState = _ref2.matchState,
    homeTeam = _ref2.homeTeam,
    eventNumber = _ref2.eventNumber,
    awayTeam = _ref2.awayTeam,
    results = _ref2.results;
  return React.createElement(SvSMatchHeader, {
    awayTeam: awayTeam,
    eventNumber: eventNumber,
    homeTeam: homeTeam,
    matchState: matchState,
    results: results
  });
};
setGlobal('svs.components.sportInfo.bigStatBanner.MatchHeader', MatchHeader);

 })(window);